import script from "./CardImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardImg.vue?vue&type=script&lang=ts&setup=true"

import "./CardImg.vue?vue&type=style&index=0&id=280b20bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280b20bc"]])

export default __exports__